var _circle, _path, _circle2, _circle3, _ellipse, _circle4, _circle5, _ellipse2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGroceryStoreCartContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7649 21.9688C12.4405 21.63 11.935 21.5386 11.5125 21.7421L10.8596 22.0567C10.2494 22.3507 10.0558 23.1263 10.4561 23.6726L18.5388 34.7035C18.6501 34.8553 18.7198 35.0334 18.7412 35.2203L21.1817 56.508C21.2431 57.0444 21.6972 57.4493 22.237 57.4493C22.8237 57.4493 23.2993 57.9249 23.2993 58.5115V64.1034C23.2993 64.7016 23.7842 65.1865 24.3824 65.1865H25.0297C25.6279 65.1865 26.1128 64.7016 26.1128 64.1034V58.5324C26.1128 57.9342 26.5977 57.4493 27.1959 57.4493H63.0125C63.6107 57.4493 64.0956 57.9342 64.0956 58.5324V64.1034C64.0956 64.7016 64.5806 65.1865 65.1788 65.1865H65.8261C66.4243 65.1865 66.9092 64.7016 66.9092 64.1034V57.8984C66.9092 57.6503 67.1103 57.4493 67.3583 57.4493C67.5422 57.4493 67.7075 57.3371 67.7755 57.1663L78.4097 30.4458C78.6927 29.7346 78.1688 28.9622 77.4033 28.9622H19.9245C19.6291 28.9622 19.3465 28.8415 19.1422 28.6282L12.7649 21.9688ZM21.3411 33.0604C21.2604 32.4139 21.7645 31.843 22.4159 31.843H72.7323C73.4884 31.843 74.0119 32.5981 73.7466 33.3061L72.3434 37.0514C72.185 37.4743 71.7808 37.7545 71.3292 37.7545H22.8836C22.3373 37.7545 21.8766 37.3477 21.8089 36.8056L21.3411 33.0604ZM22.4307 41.7854C22.35 41.1389 22.8541 40.568 23.5055 40.568H69.4636C70.2196 40.568 70.7431 41.3231 70.4778 42.0311L69.1813 45.492C69.0228 45.9149 68.6186 46.1951 68.167 46.1951H23.9377C23.3914 46.1951 22.9306 45.7883 22.8629 45.2462L22.4307 41.7854ZM24.5832 49.0087C23.9235 49.0087 23.417 49.5934 23.5111 50.2463L23.9732 53.452C24.05 53.985 24.5068 54.3806 25.0453 54.3806H64.8294C65.2614 54.3806 65.6521 54.1239 65.8235 53.7274L67.2096 50.5216C67.5188 49.8065 66.9945 49.0087 66.2155 49.0087H24.5832Z",
    fill: "#1E1E1E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0576,
    cy: 65.1865,
    r: 5.97878,
    fill: "#1E1E1E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0572,
    cy: 65.1865,
    r: 4.22031,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0574,
    cy: 65.1867,
    rx: 2.81354,
    ry: 2.81354,
    fill: "#1E1E1E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5022,
    cy: 65.1865,
    r: 5.97878,
    fill: "#1E1E1E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.5018,
    cy: 65.1865,
    r: 4.22031,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.502,
    cy: 65.1867,
    rx: 2.81354,
    ry: 2.81354,
    fill: "#1E1E1E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 24.2476,
    width: 9.25953,
    height: 6.19012,
    rx: 2.64045,
    transform: "rotate(-34.5211 7 24.2476)",
    fill: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGroceryStoreCartContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GroceryStoreCartContrast.9f629b4e6e478280ee26835b556cfb6d.svg";